import { faCancel, faCheck, faCircleCheck, faClose, faCross, faEye, faEyeSlash, faGear, faPen, faTimes, faTrash, faWarning, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TablePaginationActions from '../../../base-components/TablePaginationActions';
import { Box, CircularProgress, MenuItem, Select, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, IconButton, Menu, Button } from "@mui/material";
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import CustomModal from '../../../base-components/CustomModal';
import { Formik, useFormik } from 'formik';
import { locationSchema } from '../../../schemas';
import Popup from '../../../base-components/Popup';
import Tooltip from '@mui/material/Tooltip';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import BusinessSettingsModal from './settings/BusinessSettingsModal';
import { PageHeader } from "../../../ui";
import { getSessionUser, hasPermission } from "../../../utils/roleAccess";


const BASE_URL = process.env.REACT_APP_BASE_URL;
function Locations() {
    const navigate = useNavigate()
    const [locations , setLocations] = useState([])
    const [location , setLocation] = useState({})
    const [locationToDelete , setLocationToDelete] = useState('')
    const [locationToUpdate , setLocationToUpdate] = useState('')
    const [isAddModalOpen , setIsAddModalOpen] = useState(false)
    const [isViewModalOpen , setIsViewModalOpen] = useState(false)
    const [isDeleteModalOpen , setIsDeleteModalOpen] = useState(false)
    const [isUpdateModalOpen , setIsUpdateModalOpen] = useState(false)
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [formData , setFormData] = useState({})
    const [formErrors , setFormErrors] = useState({})
    const [page , setPage ] = useState(0)
    const [countries , setCountries] = useState([])
    const [selectedCountry , setSelectedCountry] = useState('')
    const [selectedState , setSelectedState] = useState('')
    const [selectedCity , setSelectedCity] = useState('')
    const [selectedCountryIsoCode , setSelectedCountryIsoCode] = useState('')
    const [states , setStates] = useState([])
    const [cities , setCities] = useState([])
    const [selectedStateCode , setSelectedStateCode] = useState('')
    const [showPassword , setShowPassword] = useState(false)
    const [isSuccessAlert , setIsSuccessAlert] = useState(false)
    const [isFaliureAlert , setIsFailureAlert] = useState(false)
    const [successMessage , setSuccessMessage] = useState('')
    const [failureMessage , setFailureMessage] = useState('')
    const [isPopupOpen , setIsPopupOpen] = useState(false)
    const [company_id , setCompanyID] = useState('')
    const [location_id , setLocationID] = useState('')
    const [role , setRole] = useState('')
    const [loading , setLoading] = useState(false)
    const [buttonLoading , setButtonLoading] = useState(false)     
    // Anchor state for the actions menu
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const openAnchor = Boolean(anchorEl);
    const [isBusinessSettingsModalOpen, setIsBusinessSettingsModalOpen] = useState(false);
    const [businessLocation, setBusinessLocation] = useState(null);

    const handleClickAnchor = (event, location) => {
      setAnchorEl(event.currentTarget);
      console.log("Selected location:", location);
      setSelectedLocation(location);
    }
    const handleCloseAnchor = () => {
      setAnchorEl(null);
      setSelectedLocation(null);
    }
    useEffect(() => {
        const sessionStr = sessionStorage.getItem('user-info');
        if (sessionStr) {
            const session = JSON.parse(sessionStr);
            setRole(session.user.role);
            setCompanyID(session.user.company_id);
            setLocationID(session.user.location_id);
        } else {
            navigate('/login');
        }
    }, []);
    
    useEffect(() => {
        if(role){
            setLoading(true)
            getLocations();
            getCountries();
            setTimeout(()=> {
                setLoading(false)
            },1000)
        }
            
    }, [role]);

    async function getCountries () {
        await fetch(BASE_URL + `country/getCountries`)
        .then((response) => response.json())
        .then((data) => {
            setCountries(data)
            
        })
        .catch((error) => console.log(error));
    
    }

    const handleSelectCountry = (value) => {
        setSelectedCountryIsoCode(value);
        const con = countries.filter(country => country.isoCode === value)
        const countryName = con.length > 0 ? con[0].name : null;
        setSelectedCountry(countryName)
        getStates(value);
        getCities(value)
    }

     const getStates = async(value) => {
       await fetch(BASE_URL + `country/getStatesById/${value}`)
        .then((response) => response.json())
        .then((data) => {
            setStates(data)
            
        })
        .catch((error) => console.log(error));
    }

    const handleSelectState = (value) => {
        setSelectedStateCode(value);
        const con = states.filter(state => state.isoCode === value)
        const stateName = con.length > 0 ? con[0].name : null;
        setSelectedState(stateName)
    }
    
    const getCities = async (value) => {
        await fetch(BASE_URL + `country/getCitiesById/${value}`)
        .then((response) => response.json())
        .then((data) => {
            setCities(data)
        })
        .catch((error) => console.log(error));
    }
    
    async function getLocations() {
        let endpoint = '';
        console.log(role);
    
        if (role === 'SuperAdmin') {
            endpoint = 'locations/getLocations';
        } else if (role === 'Admin') {
            endpoint = `locations/getLocationsByCompanyID/${company_id}`;
        }
    
        try {
            const response = await fetch(BASE_URL + endpoint);
    
            console.log("response: ", response);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            console.log("Fetched data: ", data);
            setLocations(data.locations ); 
          
        } catch (error) {
            console.error("Error fetching locations: ", error);
        }
    }

    // async function getLocations () {
    //     let endpoint = '';
    //     console.log(role);
    //     if (role === 'SuperAdmin') {
    //         endpoint = 'locations/getLocations';
    //     } else if (role === 'Admin') {
    //         endpoint = `locations/getLocationsByCompanyID/${company_id}`;
    //     }
    //     await fetch(BASE_URL + endpoint)
    //     .then((response) => response.json())
    //     .then((data) => {
    //         console.log('data: ' , data);
    //         setLocations(data.locations)
    //     })
    //     .catch((error) => console.log(error));
    // }


    async function getLocationByID (id) {
      console.log('Fetching location by ID: ', id);
        await fetch(BASE_URL + `locations/getLocationById/${id}`)
        .then((response) => response.json())
        .then((data) => {
            console.log('Location data: ', data);
            setLocation(data.location)
            setValues({
                name: data.location.name,
                email: data.location.email,
                password: data.location.password,
                phone_number: data.location.phone_number,
                description: data.location.description,
                address: data.location.address,
                country: data.location.country,
                state: data.location.state,
                city: data.location.city,
                postal_code: data.location.postal_code,
                opening_hours: data.location.opening_hours,
                closing_hours: data.location.closing_hours,
                company_id: data.location.company_id,
                member_id_temp: data.location.member_id_temp || ''
            });
        })
        .catch((error) => console.log(error));
    }
    
    const handleAddLocation = async (values, actions) => {
        setButtonLoading(true);
        values.company_id = company_id;

            const requestOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(values),
            };
            console.log(company_id);
            
            try {
                const response = await fetch(BASE_URL + `locations/createLocation`, requestOptions);
    
                console.log('Response status:', response.status);
                if (!response.ok) {
                    console.error('Response not ok:', response);
                    setIsFailureAlert(true)
                    failureMessage('Failed to add Location')
                    // handleFailureOpen('Failed to Add Add');
                } else {
                    const responseData = await response.json();
                    console.log('Response data:', responseData);
                    setIsAddModalOpen(false)
                    actions.resetForm()
                    getLocations()
                    setIsSuccessAlert(true)
                    setSuccessMessage('Location added Successfully')
                    setIsPopupOpen(true)
                    setTimeout(() => {
                        setIsPopupOpen(false)
                    } , 5000)
                }
            } catch (error) {
                console.error('Caught error:', error);
                setIsFailureAlert(true) 
                setFailureMessage('Failed to add Location')
                setIsPopupOpen(true)
                setTimeout(() => {
                    setIsPopupOpen(false)
                } , 5000)
            } finally {
                setButtonLoading(false);
            }
            
    
    }
    

    const handleUpdateLocation = async (values, actions) => {
        setButtonLoading(true);
        values.company_id = company_id;
        const requestOptions = {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(values),
        };

        try {
            const response = await fetch(BASE_URL + `locations/updateLocation/${locationToUpdate}`, requestOptions);

            console.log('Response status:', response.status);
            if (!response.ok) {
                console.error('Response not ok:', response);
                setIsFailureAlert(true)
                setFailureMessage('Failed to Update Location')
                setIsPopupOpen(true)
                setTimeout(() => {
                    setIsPopupOpen(false)
                }, 5000)
            } else {
                const responseData = await response.json();
                console.log('Response data:', responseData);
                actions.resetForm()
                setIsUpdateModalOpen(false)
                getLocations()
                setIsSuccessAlert(true)
                setSuccessMessage('Location Updated Successfully')
                setIsPopupOpen(true)
                setTimeout(() => {
                    setIsPopupOpen(false)
                }, 5000)
            }
        } catch (error) {
            console.error('Caught error:', error);
            setIsFailureAlert(true)
            setFailureMessage('Failed to Update Location')
            setIsPopupOpen(true)
            setTimeout(() => {
                setIsPopupOpen(false)
            }, 5000)
        } finally {
            setButtonLoading(false);
        }

}

    async function deleteLocation () {
        setButtonLoading(true);
        const requestOptions = {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            },
        };
        await fetch(BASE_URL + `locations/deleteLocation/${locationToDelete}` , requestOptions)
        .then((response) => response.json())
        .then((data) => {
            getLocations()
            setIsDeleteModalOpen(false)
            setIsSuccessAlert(true)
            setSuccessMessage('Location deleted Successfully')
            setIsPopupOpen(true)
            setTimeout(() => {
                setIsPopupOpen(false)
            }, 5000)
        })
        .catch((error) => {
            console.log(error)
            setIsFailureAlert(true)
            setFailureMessage('Failed to delete Location')
            setIsPopupOpen(true)
            setTimeout(() => {
                setIsPopupOpen(false)
            }, 5000)
        }).finally(() => {
            setButtonLoading(false)
        });
    }


    function toggleAddModal() {
        setIsAddModalOpen(!isAddModalOpen)
        resetForm()
    }
    function toggleViewModal() {
        setIsViewModalOpen(!isViewModalOpen)
        resetForm()
    }

    function toggleUpdateModal() {
        setIsUpdateModalOpen(!isUpdateModalOpen)
        resetForm()
    }
    function toggleDeleteModal() {
        setIsDeleteModalOpen(!isDeleteModalOpen)
    }

    function showAddModal(id) {
        setIsAddModalOpen(true);
    }
    function showViewModal(id) {
        getLocationByID(id);
        setIsViewModalOpen(true);
    }
    function showUpdateModal(id) {

        getLocationByID(id);
        setLocationToUpdate(id);
        setIsUpdateModalOpen(true);
    }
    function showDeleteModal(id) {
        setLocationToDelete(id);
        setIsDeleteModalOpen(true);
    }
    

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
      };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
      };

    const {values , touched , errors , handleBlur , handleChange , handleSubmit , setValues , resetForm} = useFormik({
        initialValues: {
            name: '',
            email: '',
            phone_number: '',
            description: '',
            password:'',
            address:'',    
            country: '',    
            state: '',
            city: '',
            postal_code: '',
            opening_hours: '',
            closing_hours: '',
            company_id: company_id ? company_id : '',
            member_id_temp: ''
        },
        validationSchema: locationSchema(isUpdateModalOpen),
        onSubmit: (values, actions) => {
            if(isAddModalOpen){
                handleAddLocation(values, actions); // Call the external function
            } else if(isUpdateModalOpen) {
                handleUpdateLocation(values, actions);
            }
        },
    })

  return (
    <>
        <div className="m-5">
          <PageHeader
            title="Locations"
            actions={
              hasPermission(getSessionUser(), 'locations:create') ? (
                  <button className='gx-cta ' onClick={showAddModal}>Add Location</button>
              ) : null
            }
          />
        </div>
        {
          loading ? (
             
               <div className="flex justify-center items-center mt-20 relative">
                 {/* SVG Gradient Definition */}
                 <svg width="0" height="0">
                   <defs>
                     <linearGradient id="gradientColors" x1="1" y1="0" x2="0" y2="1">
                       <stop offset="0%" stopColor="#D71920" />
                       <stop offset="100%" stopColor="#F7931E" />
                     </linearGradient>
                   </defs>
                 </svg>
         
                 {/* Circular Progress with Gradient Stroke */}
                 <CircularProgress
                   thickness={4}
                   size={35}
                   sx={{
                     'svg circle': {
                       stroke: 'url(#gradientColors)', // Apply gradient stroke
                     },
                   }}
                 />
               </div>
             
           ) : (
            locations && locations.length !== 0 ? (     
                <Box className="bg-gx-surface rounded-gx border border-gx-border shadow-gx m-5 animate-fadeIn overflow-y-auto  overflow-x-auto">
                    <Table>
                      <TableHead>
                          <TableRow >
                              <TableCell>Name</TableCell>
                              <TableCell>Address</TableCell>
                              <TableCell>Phone</TableCell>
                              <TableCell>Open Time</TableCell>
                              <TableCell>Close Time</TableCell>
                              <TableCell>Actions</TableCell>
                          </TableRow>
                      </TableHead>
                      <TableBody>
                        {
                          locations.map((location, index) => (
                              <TableRow hover key={index}>
                              <TableCell>{location.name}</TableCell>
                              <TableCell>{location.address}</TableCell>
                              <TableCell>{location.phone_number}</TableCell>
                              <TableCell>{location.opening_hours}</TableCell>
                              <TableCell>{location.closing_hours}</TableCell>
                              <TableCell>
                                <div className='flex gap-2'>
                                  <IconButton onClick={(e) => handleClickAnchor(e, location)}>
                                    <MoreVertIcon />
                                  </IconButton>
                                  <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseAnchor}>
                                    <MenuItem
                                      onClick={() => {
                                        setIsBusinessSettingsModalOpen(true);
                                        handleCloseAnchor();
                                        setBusinessLocation(selectedLocation);
                                      }}
                                    >
                                      <FontAwesomeIcon icon={faGear} className='mr-2' /> Business Settings
                                    </MenuItem>
                                    <MenuItem
                                      onClick={() => {
                                        showViewModal(selectedLocation._id);
                                        handleCloseAnchor();
                                      }}
                                    >
                                      <FontAwesomeIcon icon={faEye} className='mr-2' /> View
                                    </MenuItem>
                                    {hasPermission(getSessionUser(), 'locations:update') && (
                                    <MenuItem
                                      onClick={() => {
                                        showUpdateModal(selectedLocation._id);
                                        handleCloseAnchor();
                                      }}
                                    >
                                      <FontAwesomeIcon icon={faPen} className='mr-2' /> Update
                                    </MenuItem>
                                    )}
                                    {hasPermission(getSessionUser(), 'locations:delete') && (
                                    <MenuItem
                                      onClick={() => {
                                        showDeleteModal(selectedLocation._id);
                                        handleCloseAnchor();
                                      }}
                                    >
                                      <FontAwesomeIcon icon={faTrash} className='mr-2' /> Delete
                                    </MenuItem>
                                    )}
                                  </Menu>
                                </div>
                              </TableCell>
                            </TableRow>
                          ))

                        }
                      </TableBody>
                      <TableFooter>
                          <TableRow>
                          <TablePagination
                              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                              colSpan={12}
                              count= {locations.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              slotProps={{
                                  select: {
                                  inputProps: {
                                      'aria-label': 'rows per page',
                                  },
                                  native: true,
                                  },
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                              />
                          </TableRow>
                      </TableFooter>
                  </Table>
                </Box>
                ) : (
                  <div className='bg-gx-border w-ful p-3 mt-10 rounded-lg m-10'>
                    <h3 className='text-xl font-bold text-center text-gx-ink-soft'>No Records Found</h3>
                  </div>
                )
          )
            
          }

<CustomModal isModal={isAddModalOpen || isUpdateModalOpen} handleModal={() => {
  if (isAddModalOpen) {
    toggleAddModal();
  } else if (isUpdateModalOpen) {
    toggleUpdateModal();
  }
}} size='2xl'>
  <h1 className='font-bold text-xl sm:text-2xl md:text-3xl text-gx-ink-soft p-3 sm:p-4 md:p-5 border-b mx-1 sm:mx-2'>
    {isAddModalOpen ? 'Add Location' : 'Update Location'}
  </h1>
  
  <form onSubmit={handleSubmit} className='text-gx-ink-soft m-3 sm:m-4 md:m-5' autoComplete='off'>
    <div>
      <input type='hidden' name='company_id' value={values.company_id || ''}/>
    </div>
    
    {/* Member ID Temp and Name - Stack on mobile, side by side on larger screens */}
    <div className='flex flex-col sm:flex-row justify-between gap-3 sm:gap-5'>
      <div className='w-full mb-3 sm:mb-0'>
        <label className='block mb-1'>Member ID: <span className='text-red-500'>*</span></label>
        <input type='text' name='member_id_temp' placeholder='Enter Member ID' 
          value={values.member_id_temp}
          className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 text-sm sm:text-base ' +
            (errors.member_id_temp && touched.member_id_temp ? 'border-red-600' : '')}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.member_id_temp && errors.member_id_temp ? <p className='text-red-500 pl-2 italic text-xs sm:text-sm'>{errors.member_id_temp}</p> : null}
      </div>
      <div className='w-full mb-3 sm:mb-0'>
        <label className='block mb-1'>Name <span className='text-red-500'>*</span></label>
        <input type='text' name='name' placeholder='Enter Name' 
          value={values.name}
          className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 text-sm sm:text-base '+ 
            (errors.name && touched.name ? 'border-red-600' : '')}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.name && errors.name ? <p className='text-red-500 pl-2 italic text-xs sm:text-sm'>{errors.name}</p> : null}
      </div>
    </div>
    
    {/* Description - Full width */}
    <div className='mt-3 sm:mt-5'>
      <div className='w-full'>
        <label className='block mb-1'>Description:</label>
        <input type='text' name='description' placeholder='Enter Description' 
          value={values.description}
          className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 text-sm sm:text-base '+ 
            (errors.description && touched.description ? 'border-red-600' : '')}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.description && errors.description ? <p className='text-red-500 pl-2 italic text-xs sm:text-sm'>{errors.description}</p> : null}
      </div>
    </div>
    
    {/* Password field (only for Add) and phone field - Stack for larger screens */}
    <div className='flex flex-col sm:flex-row justify-between gap-3 sm:gap-5 mt-3 sm:mt-5'>
    {isAddModalOpen && (
        <div className='w-full'>
          <label className='block mb-1'>Password <span className='text-red-500'>*</span></label>
          <div className='relative'>
            <input type={showPassword ? 'text' : 'password'} name='password' placeholder='Enter Password'
              value={values.password}
              className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 text-sm sm:text-base pr-10 '+
                (errors.password && touched.password ? 'border-red-600' : '')}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            <button type='button' className='absolute right-3 top-1/2 transform -translate-y-1/2 text-gx-ink-soft'
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye}/>}
            </button>
          </div>
          {touched.password && errors.password ? <p className='text-red-500 pl-2 mt-1 italic text-xs sm:text-sm'>{errors.password}</p> : null}
        </div>
    )}
    
    <div className='w-full'>
        <label className='block mb-1'>Phone <span className='text-red-500'>*</span></label>
        <input type='text' name='phone_number' placeholder='Enter Phone'
          value={values.phone_number}
          className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 text-sm sm:text-base '+ 
            (errors.phone_number && touched.phone_number ? 'border-red-600' : '')}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.phone_number && errors.phone_number ? <p className='text-red-500 pl-2 italic text-xs sm:text-sm'>{errors.phone_number}</p> : null}
      </div>
      
    </div>
    
    {/* Address and Email */}
    <div className='flex flex-col sm:flex-row justify-between gap-3 sm:gap-5 mt-3 sm:mt-5'>
      <div className='w-full mb-3 sm:mb-0'>
        <label className='block mb-1'>Address <span className='text-red-500'>*</span></label>
        <input type='text' name='address' placeholder='Enter Address'
          value={values.address}
          className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 text-sm sm:text-base '+ 
            (errors.address && touched.address ? 'border-red-600' : '')}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.address && errors.address ? <p className='text-red-500 pl-2 italic text-xs sm:text-sm'>{errors.address}</p> : null}
      </div>
      <div className='w-full'>
        <label className='block mb-1'>Email <span className='text-red-500'>*</span></label>
        <input type='text' name='email' placeholder='Enter Email'
          value={values.email}
          className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 text-sm sm:text-base '+ 
            (errors.email && touched.email ? 'border-red-600' : '')}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.email && errors.email ? <p className='text-red-500 pl-2 italic text-xs sm:text-sm'>{errors.email}</p> : null}
      </div>
    </div>
    
    {/* Location Fields (Country, State, City, Postal) - Stack on mobile, 2x2 grid on tablet, full row on desktop */}
    <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5 mt-3 sm:mt-5'>
      <div className='w-full'>
        <label className='block mb-1'>Country <span className='text-red-500'>*</span></label>
        <select name='country' placeholder='Enter Country'
          value={values.country}
          className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 text-sm sm:text-base '+ 
            (errors.country && touched.country ? 'border-red-600' : '')}
          onChange={(e) => {
            handleChange(e); 
            getStates(e.target.value);
            getCities(e.target.value);
          }}
          onBlur={handleBlur}
        >
          <option>Country</option>
          {countries?.map((country, index) => (
            <option key={index} value={country.isoCode}>{country.name}</option>
          ))}
        </select>
        {touched.country && errors.country ? <p className='text-red-500 pl-2 italic text-xs sm:text-sm'>{errors.country}</p> : null}
      </div>
      
      <div className='w-full'>
        <label className='block mb-1'>State <span className='text-red-500'>*</span></label>
        <select name='state' placeholder='Enter State'
          value={values.state}
          className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 text-sm sm:text-base '+ 
            (errors.state && touched.state ? 'border-red-600' : '')}
          onChange={handleChange}
          onBlur={handleBlur}
        >
          <option>State</option>
          {states?.map((state, index) => (
            <option key={index} value={state.isoCode}>{state.name}</option>
          ))}
        </select>
        {touched.state && errors.state ? <p className='text-red-500 pl-2 italic text-xs sm:text-sm'>{errors.state}</p> : null}
      </div>
      
      <div className='w-full'>
        <label className='block mb-1'>City <span className='text-red-500'>*</span></label>
        <select name='city' placeholder='Enter City' 
          value={values.city}
          className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 text-sm sm:text-base '+ 
            (errors.city && touched.city ? 'border-red-600' : '')}
          onChange={handleChange}
          onBlur={handleBlur}
        >
          <option>City</option>
          {cities?.map((city, index) => (
            <option key={index} value={city.name}>{city.name}</option>
          ))}
        </select>
        {touched.city && errors.city ? <p className='text-red-500 pl-2 italic text-xs sm:text-sm'>{errors.city}</p> : null}
      </div>
      
      <div className='w-full'>
        <label className='block mb-1'>Postal Code <span className='text-red-500'>*</span></label>
        <input type='text' name='postal_code' placeholder='Enter Postal Code' 
          value={values.postal_code}
          className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 text-sm sm:text-base '+ 
            (errors.postal_code && touched.postal_code ? 'border-red-600' : '')}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.postal_code && errors.postal_code ? <p className='text-red-500 pl-2 italic text-xs sm:text-sm'>{errors.postal_code}</p> : null}
      </div>
    </div>
    
    {/* Opening and Closing Hours */}
    <div className='flex flex-col sm:flex-row justify-between gap-3 sm:gap-5 mt-3 sm:mt-5'>
      <div className='w-full mb-3 sm:mb-0'>
        <label className='block mb-1'>Opening Hour <span className='text-red-500'>*</span></label>
        <input type='text' name='opening_hours' placeholder='Enter Opening Hour'
          value={values.opening_hours}
          className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 text-sm sm:text-base '+ 
            (errors.opening_hours && touched.opening_hours ? 'border-red-600' : '')}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.opening_hours && errors.opening_hours ? <p className='text-red-500 pl-2 italic text-xs sm:text-sm'>{errors.opening_hours}</p> : null}
      </div>
      <div className='w-full'>
        <label className='block mb-1'>Closing Hour <span className='text-red-500'>*</span></label>
        <input type='text' name='closing_hours' placeholder='Enter Closing Hour'
          value={values.closing_hours}
          className={'border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 text-sm sm:text-base '+ 
            (errors.closing_hours && touched.closing_hours ? 'border-red-600' : '')}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.closing_hours && errors.closing_hours ? <p className='text-red-500 pl-2 italic text-xs sm:text-sm'>{errors.closing_hours}</p> : null}
      </div>
    </div>
    
    {/* Submit Button */}
    <div className="flex justify-end items-center pt-3 mt-3 border-t">
      <Button
        variant="contained"
        color="success"
        fullWidth 
        type='submit' 
        disabled={buttonLoading}
      >
        Submit
        {buttonLoading && (
          
            <div className='ml-2 mt-1'><CircularProgress size={20} color='#fff'/></div>
          
        )}
      </Button>
    </div>
  </form>
</CustomModal>
      
      <CustomModal isModal={isViewModalOpen} handleModal={toggleViewModal} size="2xl">
  
    <div>
      <Tooltip title="" placement="bottom">
        <h1 className="font-bold text-xl sm:text-2xl md:text-3xl text-gx-ink-soft p-3 sm:p-4 md:p-5 border-b mx-1 sm:mx-2">
          View Location
        </h1>
        <div className="m-4 sm:m-8 md:m-14 overflow-x-auto">
          <Box sx={{ width: '100%', display: 'table', tableLayout: 'fixed' }}>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell className="font-medium w-1/3 sm:w-1/4">Name</TableCell>
                  <TableCell className="break-words">{location.name}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="font-medium w-1/3 sm:w-1/4">Description</TableCell>
                  <TableCell className="break-words">{location.description}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="font-medium w-1/3 sm:w-1/4">Email</TableCell>
                  <TableCell className="break-words">{location.email}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="font-medium w-1/3 sm:w-1/4">Address</TableCell>
                  <TableCell className="break-words">
                    {location.address}, {location.city}, {location.state}, {location.country}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="font-medium w-1/3 sm:w-1/4">Opening Time</TableCell>
                  <TableCell className="break-words">{location.opening_hours}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="font-medium w-1/3 sm:w-1/4">Closing Time</TableCell>
                  <TableCell className="break-words">{location.closing_hours}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="font-medium w-1/3 sm:w-1/4">Phone No</TableCell>
                  <TableCell className="break-words">{location.phone_number}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>
        </div>
      </Tooltip>
    </div>
  
</CustomModal>
      {
        isPopupOpen && (
            <Popup 
             onClose={() => setIsPopupOpen(false)}
             alertType={isSuccessAlert ? 'success' : isFaliureAlert ? 'failure' : ''}
             message={isSuccessAlert ? successMessage : isFaliureAlert ? failureMessage : ''}
             />
                
        )
      }
      
      <CustomModal isModal={isDeleteModalOpen} handleModal={toggleDeleteModal} size='md'>
  <div className='p-4 sm:p-5'>
    <h2 className="text-lg sm:text-xl font-medium">Delete Location?</h2>
    <p className="text-gx-ink-soft mt-2 sm:mt-3 text-sm sm:text-base">
      Are you sure you want to delete this location?
    </p>
    <div className="mt-4 sm:mt-5 flex justify-end">
      <Button
        variant="contained"
        color="error"
        fullWidth
        disabled={buttonLoading}
        onClick={deleteLocation}
      >
        Delete
        {buttonLoading && (
          
            <div className='ml-2 mt-1'><CircularProgress size={20} color='#fff'/></div>
          
        )}
      </Button>
    </div>
  </div>
</CustomModal>
        <BusinessSettingsModal 
          open={isBusinessSettingsModalOpen} 
          onClose={() => setIsBusinessSettingsModalOpen(false)} 
          location={businessLocation}
        />
    </>
  )
}

export default Locations